import Vue from 'vue';
import Router from 'vue-router';
import config from '../config/apiUrl';
import commonConfig from '../config/common';

Vue.use(Router);


export default new Router({
  mode: 'history',
  routes: [
    {
      path: '/',
      name: 'search',
      component: require('@/components/SearchingCarsPage').default,
      props: {api: config, common: commonConfig},
    },
    {
      path: '/list',
      name: 'list',
      component: require('@/components/ListPage').default,
      props: {api: config},
    },
    {
      path: '/detailMap',
      name: 'detailMap',
      component: require('@/components/MapPage').default,
      props: {api: config},
    },
    {
      path: '/empty',
      name: 'empty',
      component: require('@/components/EmptyPage').default,
    },
    {
      path: '*',
      redirect: '/',
    },
  ],
});
